<template>
  <div class="main-body">
    <div class="header">扣款统计</div>
    <div class="out">

      <div class="search2">

        <div style="float: right">

          <el-select v-model="institutionCode" @change="insChange" placeholder="请选择机构" style="margin-right: 5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-checkbox-group v-model="checkboxGroup1" size="mini" @change="tab_change" style="display: inline-block;float: right;">
            <el-checkbox-button v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox-button>
          </el-checkbox-group>

        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData"
                :height="th" border >

        <el-table-column v-if="this.checkboxGroup1[0] == '按年'" prop="year" label="年份" width="200"></el-table-column>

        <el-table-column v-if="this.checkboxGroup1[0] == '按月'" prop="month" label="月份" width="200"></el-table-column>

        <el-table-column v-if="this.checkboxGroup1[0] == '按天'" prop="day" label="日期" width="200"></el-table-column>

        <el-table-column prop="lessBalance" label="扣款" width="200"></el-table-column>

        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <p>{{scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


//const cityOptions = ['上海', '北京', '广州', '深圳'];

export default {
  name: "Page",
  components:{

  },

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      tableLoading:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      status:-1,

      cities: ['按天', '按月', '按年'],
      checkboxGroup1: ['按天'],


      type:2,

      arr_ins:[],
      institutionCode: '',


    }
  },

  created(){
    this.getIns(false);
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getListDay();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    tab_change(val){
      //console.log(val.length);

      if(val.length == 0){
        let arr = [];
        arr.push('按天');
        this.checkboxGroup1 = arr;
        //console.log(this.checkboxGroup1);
      }
      else{
        let arr = [];
        arr.push(val[val.length-1]);
        this.checkboxGroup1 = arr;
        //console.log(this.checkboxGroup1);
      }

      if(this.checkboxGroup1[0] == '按天'){
        this.getListDay(true);
      }
      if(this.checkboxGroup1[0] == '按月'){
        this.getListMonth(true);
      }
      if(this.checkboxGroup1[0] == '按年'){
        this.getListYear(true);
      }


    },

    insChange(val){

      this.institutionCode = val;
      this.tableData = [];
      this.totalItems = 0;

      this.checkboxGroup1 = [];

    },

    current_change:function(currentPage){
      this.currentPage = currentPage;

      if(this.checkboxGroup1[0] == '按天'){
        this.getListDay(false);
      }
      if(this.checkboxGroup1[0] == '按月'){
        this.getListMonth(false);
      }
      if(this.checkboxGroup1[0] == '按年'){
        this.getListYear(false);
      }

    },

    getListDay(isSearch) {
      if(isSearch)this.currentPage=1

      let that = this;

      that.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Total/GovPageTotalLessDayIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        that.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        that.tableLoading=false
        console.log(error);
      });
    },

    getListMonth(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Total/GovPageTotalLessMonthIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },

    getListYear(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Total/GovPageTotalLessYearIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },



  }
}
</script>

<style lang="scss" scoped>

</style>
